import { useState } from "react";
import { BiX } from "react-icons/bi";
import { useAsyncDebounce } from "react-table";

// interface TextFieldColumnFilterProps<T extends object> extends FilterProps<T> {}

/*
function TextFieldColumnFilter<T extends object>({
  column: { filterValue, setFilter, Header },
}: TextFieldColumnFilterProps<T>)
*/

function TextFieldColumnFilter({ column, manualPagination, totalRows }) {
  const { filterValue, setFilter, id, preFilteredRows } = column;
  const [value, setValue] = useState(filterValue || "");
  const count = preFilteredRows?.length ?? 0;

  const onClear = (event) => {
    event.stopPropagation();
    setFilter(undefined);
    setValue(undefined);
  };

  const handleChangeFilterValue = useAsyncDebounce((newValue) => {
    setFilter(newValue || undefined);
  }, 500);

  return (
    <div className="tw-relative">
      <button
        className={`tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-bg-transparent tw-rounded-full tw-outline-none tw-border-0 tw-pr-2 focus:tw-outline-none ${
          filterValue ? "tw-opacity-100" : "tw-opacity-50"
        }`}
        type="button"
        title="Clear"
        onClick={onClear}
      >
        <BiX className="tw-w-5 tw-h-5" />
      </button>

      <input
        id={id}
        type="text"
        className="form-control form-control-sm tw-overflow-ellipsis tw-pr-6"
        value={value || ""}
        onChange={(event) => {
          handleChangeFilterValue(event.target.value || undefined);
          setValue(event.target.value || undefined);
        }}
        placeholder={`Search ${
          manualPagination ? totalRows : count
        } records...`}
      />
    </div>
  );
}

export default TextFieldColumnFilter;
